import assert from 'assert'
import React from 'react'

import { Box } from '../Box/Box'

export interface ProgressBarProps {
  tone?: 'action' | 'positive'
  max: number
  current: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  tone = 'action',
  max = 10,
  current = 0,
}) => {
  assert(max > 0, `Invalid max: ${max}. Must be greater than 0`)

  const getProgressWidth = () => {
    return `${(current / max) * 100}%`
  }

  return (
    <Box
      className="progress-bar--track"
      background="var(--colors-hairline)"
      width="100%"
      height={1}
      position="relative"
    >
      <Box
        className="progress-bar--indicator"
        background={`var(--colors-${tone})`}
        position="absolute"
        left={0}
        top={0}
        height={1}
        width={getProgressWidth()}
      />
    </Box>
  )
}
